module.exports = __webpack_public_path__ + "img/call.db01396f.svg";